import React from 'react';
import { Alert, Input } from 'reactstrap';
import AllNumber from './AllNumber';
import SortIcons from '../ProposalsSortIcons';
import utils from '../../lib/utils';
import { getPermissionForComponent } from '../../utils/permissionsUtils';

const AllNumbersList = ({
  numbers = [],
  onRevoke,
  onEdit,
  onAssignCompany,
  onDelete,
  onAssign,
  user,
  gateways,
  selectRoute,
  onSort,
  sortValue,
  onShowLog,
  onCheckboxChange,
  onSelectAllChange,
  selectAllChecked,
  selectedNumbers,
  selectedBulkAction
}) => {
  const numberBulkActionsAccess = getPermissionForComponent('numberBulkActionsAccess',user.permissionsGroup);
  const numberBulkAssignmentAccess = getPermissionForComponent('numberBulkAssignmentAccess', user.permissionsGroup);
  const canSelectNumbers = numberBulkActionsAccess === 'write' || numberBulkActionsAccess === 'both'
    || numberBulkAssignmentAccess === 'write' || numberBulkAssignmentAccess === 'both';

  return (
    <div className="table-header-fixed">
      <table>
        <thead style={{ zIndex: 1, position: 'sticky' }}>
          <tr>
          <th
              className="cursor-pointer"
              onClick={() => onSort('number')}
              style={{ textAlign: 'left' }}
            > 
            { canSelectNumbers &&
              <Input
                type="checkbox"
                name="selectAll"
                onChange={(e) => onSelectAllChange(e.target.checked)}
                checked={selectAllChecked}
                onClick={(e) => e.stopPropagation()}
                style={{ margin: 0, marginTop: '4px' }}
              />
            }
              <span style={{  marginLeft: canSelectNumbers ? '20px' : null }}>
                Number <SortIcons sortObj={sortValue} sortName="number" />
              </span>
            </th>
            <th className="cursor-pointer">Device Name</th>
            <th className="cursor-pointer" onClick={() => onSort('temporary')}>
              Temp DID <SortIcons sortObj={sortValue} sortName="temporary" />
            </th>
            <th className="cursor-pointer" onClick={() => onSort('company[name]')}>
              Company <SortIcons sortObj={sortValue} sortName="company[name]" />
            </th>
            {
              utils.filterCustomer(user?.role) ? (
                <th className="cursor-pointer" onClick={() => onSort('carrier')}>
                  Carrier <SortIcons sortObj={sortValue} sortName="carrier" />
                </th>
              ) : null
            }
            <th className="cursor-pointer" onClick={() => onSort('type')}>
              Type <SortIcons sortObj={sortValue} sortName="type" />
            </th>
            {user.role === 'superAdmin' ||
              user.role === 'companyGroupAdmin' ||
              user.role === 'supportEngineer' ? (
              <th>Route</th>
            ) : null}
            <th className="cursor-pointer" onClick={() => onSort('dateCreated')}>
              Date Added <SortIcons sortObj={sortValue} sortName="dateCreated" />
            </th>
            {
              utils.filterCustomer(user?.role) ? (
                <th colSpan="3">Actions</th>) : null
            }

          </tr>
        </thead>
        <tbody>
          {numbers.length ? (
            numbers.map(number => (
              <AllNumber
                user={user}
                key={number._id}
                number={number}
                onRevoke={onRevoke}
                onEdit={onEdit}
                onAssignCompany={onAssignCompany}
                onAssign={onAssign}
                onDelete={onDelete}
                selectRoute={selectRoute}
                gateways={gateways}
                onShowLog={onShowLog}
                onCheckboxChange={onCheckboxChange}
                isChecked={selectedNumbers?.includes(number?._id)}
                selectedBulkAction={selectedBulkAction}
              />
            ))
          ) : (
            <tr>
              <td colSpan={10}>
                <Alert colSpan={10} color="info">
                  No Numbers Found. Start by adding a new number.
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AllNumbersList;
